import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Anchor } from "lucide-react";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function submit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/admin/login", {
                email,
                password,
            });
            localStorage.setItem("admin_token", data.token);
            toast.success("Benvenuto a bordo, Capitano!");
            navigate("/admin/dashboard");
        } catch (err) {
            const msg =
                err?.response?.data?.detail || "Credenziali non valide";
            toast.error(typeof msg === "string" ? msg : "Errore");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-[70vh] flex items-center justify-center px-5 py-12" data-testid="admin-login-page">
            <form
                onSubmit={submit}
                className="w-full max-w-md bounty-card p-10 relative"
            >
                <div className="tape -top-3 left-10" />
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-bounty border-2 border-ink shadow-manga flex items-center justify-center">
                        <Anchor size={20} className="text-parchment" />
                    </div>
                    <div>
                        <div className="font-hand text-xl text-bounty -mb-1">
                            accesso capitano
                        </div>
                        <div className="font-display text-3xl tracking-tight">
                            PANNELLO ADMIN
                        </div>
                    </div>
                </div>

                <label className="font-mono text-xs tracking-widest uppercase">
                    email
                </label>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-manga mt-1 mb-4"
                    placeholder="admin@desashop.net"
                    data-testid="admin-email-input"
                />

                <label className="font-mono text-xs tracking-widest uppercase">
                    password
                </label>
                <input
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="input-manga mt-1 mb-6"
                    placeholder="••••••••"
                    data-testid="admin-password-input"
                />

                <button
                    type="submit"
                    disabled={loading}
                    className="btn-manga btn-manga-red w-full"
                    data-testid="admin-login-btn"
                >
                    {loading ? "Salpando..." : "Salpa"}
                </button>
            </form>
        </div>
    );
}
